import { useWebsiteSettings } from 'client/store'
import { useCallback } from 'react'
import { FeatureFlagsEnum } from 'src/editor/shared/growthbook/feature-flags-enum'
import { useFeatureFlag } from 'src/editor/shared/growthbook/use-feature-flag'
import { useUpdateStoreObject } from 'src/editor/shared/hooks/use-update-store'
import {
  setWebsiteDraftTheme,
  setWebsiteTheme,
} from 'src/editor/store/website-settings/website-settings-actions'
import { getWebsiteDraftTheme } from 'src/editor/store/website-settings/website-settings-selector'

export const useCommitWebsiteDraftThemeAfterSave = () => {
  const isWebsiteNewSaveLogic = useFeatureFlag(
    FeatureFlagsEnum.WebsiteNewSaveLogic,
  )
  const websiteDraftTheme = useWebsiteSettings(getWebsiteDraftTheme)
  const updateWebsiteDraftTheme = useUpdateStoreObject(setWebsiteDraftTheme)
  const updateWebsiteTheme = useUpdateStoreObject(setWebsiteTheme)

  return useCallback(() => {
    if (!isWebsiteNewSaveLogic) {
      return
    }

    if (!websiteDraftTheme) {
      return
    }

    updateWebsiteTheme(websiteDraftTheme)
    updateWebsiteDraftTheme(null)
  }, [
    isWebsiteNewSaveLogic,
    updateWebsiteDraftTheme,
    updateWebsiteTheme,
    websiteDraftTheme,
  ])
}
